import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ComponentType} from '@angular/cdk/overlay';

export const customNgValueAccessor = (hostComponent: ComponentType<any>): any => {
    return {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => hostComponent),
        multi: true
    };
};

@Component({template: ''})
export abstract class ControlValueAccessorComponent implements ControlValueAccessor {

    public get internalModel(): any {
        return this._internalModel;
    }

    protected _internalModel: any;
    protected _formControlDisabled = false;

    public onTouched = (_) => {};
    public onChange = (value: any) => {};

    registerOnChange(fn: (_: any) => void): void {
        /**
         * onChange() must be called if the _internalModel changed and change should be propagated
         * to bounded ngModel or formControl on host
         */
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        /**
         * Value comes from ngModel or formControl binding on host component.
         * Update the _internalModel with given value without calling onChange()
         */
        this.updateInternalModel(value);
    }

    setDisabledState(isDisabled: boolean) {
        /**
         * Called if the ControlValueAccessors input is a formControl and the control is disabled / enabled
         */
        this._formControlDisabled = isDisabled;
    }

    public updateInternalModel(updatedValue: any, emitValue = false) {
        this._internalModel = updatedValue;
        if (emitValue) {
            this.emitChangedValue(this._internalModel);
        }
    }

    public emitChangedValue(value: any) {
        this.onChange(value);
    }

}
